module.exports = __webpack_public_path__ + "static/img/3.88b4229.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/zh/3.png
// module id = WViB
// module chunks = 0